import React, { Component } from 'react';
import noop from 'mz-utils/noop';
import moment from 'moment';
import builder from './builder';
import ResponsiveSearchForm from './ResponsiveSearchForm'
import { Form } from './elements'
import { SearchResultsPageContext } from 'app/pages/SearchResultsPage/SearchResultsPageContext';


/**
 * Desktop/tablet version of search form in search results
 */
export class DesktopSearchForm extends Component {
  static contextType = SearchResultsPageContext;

  constructor(props) {
    super(props);
    // keep period between pickup and return dates
    this.handleFormSubmit = this.props.handleSubmit(this.handleFormSubmit);
  }

  componentWillUnmount() {
    if (this.unsubscribe) this.unsubscribe();
  }

  handleFormSubmit = (data) => {
    if (this.props.anyTouched) {
      this.context.handleSearch(performance.now(), data);
      this.props.doSearch();
    }

    // On submit, all fields are touched.
    // We need to re-initialize with new data.
    this.props.initialize(data);
  }

  handleSwap = () => {
    if (this.props.searching) return;
    this.props.swapLocations();
  }

  get isPickupInThePast() {
    const { pickup_datetime } = this.props;
    const currTime = moment();
    return pickup_datetime && pickup_datetime.isBefore(currTime);
  }

  render() {
    const { pickup_datetime, start_address = {}, end_address } = this.props;
    const { mode, isHourlyRideSearch, placeParams } = this.props;
    const isRoundTrip = mode === 'round_trip';

    return (
      <Form
        onSubmit={this.handleFormSubmit}
        ref={node => this.formNode = node}
      >
        <ResponsiveSearchForm
          fieldAppearance="compact"
          isRoundTrip={isRoundTrip}
          onSwapLocations={this.handleSwap}
          isHourlyRideSearch={isHourlyRideSearch}
          pickupDatetime={pickup_datetime}
          startAddress={start_address}
          endAddress={end_address}
          searching={this.props.searching}
          anyTouched={this.props.anyTouched}
          withSubmitButton
          placeParams={placeParams}
        />
      </Form>
    );
  }
}

// TODO: move to Flow types
// DesktopSearchForm.propTypes = {
//   doSearch: PropTypes.func.isRequired,
//   swapLocations: PropTypes.func.isRequired,
//   mode: PropTypes.string,
//   onLoad: PropTypes.func,
//   // form props
//   pickup_datetime: PropTypes.object,
//   useLandingTime: PropTypes.bool,
//   isHourlyRideSearch: PropTypes.bool,
//   change: PropTypes.func
// };

DesktopSearchForm.defaultProps = {
  onLoad: noop
};

export default builder(DesktopSearchForm);
